import EventEmitter from "events";
import { createSyntheticMap, SyntheticMap } from "../models/SyntheticMap";
import { loadModel, loadOrgRecords, saveModel } from "./connection";
import { getUser } from "./auth";
import { getCollectionName } from "../models/ModelNavigator";

export enum MapServiceEvents {
  MapLoad = 'MapLoad',
  MapSave = 'MapSave',
}

export class MapService {
  mapFloorFactory: any;
  mapList: any;
  public async loadMap(id: string): Promise<SyntheticMap | undefined> {
    this.map = createSyntheticMap(id);
    await loadModel(this.map);
    // console.log({ map: this.map });
    this.eventer.emit(MapServiceEvents.MapLoad, this.map);
    return this.map;
  }
  public async loadAllMaps(): Promise<SyntheticMap[]> {
    const user = await getUser();
    if (!user) {
      throw new Error('User not found');
    }
    const collection = getCollectionName(createSyntheticMap());
    const res = await loadOrgRecords<SyntheticMap>(collection);
    for (const map of res) {
      if (!map.name) {
        map.name = 'No Name';
      }
    }
    return res;
  }
  public async saveMap(isNew: boolean = false) {
    const user = await getUser();
    if (!user) {
      throw new Error('User not found');
    }
    this.map.orgId = user.orgId;
    if (isNew) {
      this.map._id = '';
    }
    this.eventer.emit(MapServiceEvents.MapSave, this.map);
    await saveModel(this.map);
    console.log("Saving map:", {
      id: this.map._id,
      name: this.map.name,
      environment: this.map.environment,
      floorTexture: this.map.floorTexture
    });
  }
  public setup(eventer: EventEmitter) {
    this.eventer = eventer;
  }
  public map: SyntheticMap = createSyntheticMap();
  private eventer!: EventEmitter;
}
